import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useDebounce } from '@/hooks/useDebounce';

export interface ChatSearchHit {
  thread_id: string;
  title: string | null;
  updated_at: string;
  snippet: string | null;
}

/** Searches the signed-in person's own chat titles and messages (private by access rules). */
export function useChatSearch(query: string) {
  const q = useDebounce(query.trim(), 300);
  const [hits, setHits] = useState<ChatSearchHit[]>([]);
  const [searching, setSearching] = useState(false);

  useEffect(() => {
    if (q.length < 2) { setHits([]); setSearching(false); return; }
    let live = true;
    setSearching(true);
    (supabase.rpc as any)('search_my_chats', { p_query: q, p_limit: 15 }).then(({ data }: any) => {
      if (!live) return;
      setHits((data as ChatSearchHit[]) ?? []);
      setSearching(false);
    });
    return () => { live = false; };
  }, [q]);

  return { active: query.trim().length >= 2, hits, searching };
}
